import clsx from 'clsx'
import React, { useEffect } from 'react'
import ReactPaginate from 'react-paginate'
import { URLSearchParamsInit, useSearchParams } from 'react-router-dom'

import type { IPagination } from '../../types'

type PaginationProps = {
    onPageChange?: (page: number) => void
    pagination?: IPagination
    className?: string
}

const Pagination: React.FC<PaginationProps> = ({
    pagination = {
        page: 1,
        maxPages: 1,
    },
    onPageChange,
    className,
}) => {
    const [searchParams, setSearchParams] = useSearchParams()
    const initialPage = +(searchParams.get('page') || 1) - 1
    const handlePageChange = (page: number) => {
        setSearchParams((prev: URLSearchParams) => {
            prev.set('page', String(page))
            return prev
        })
        onPageChange && onPageChange(page)
    }
    if (!pagination) return null
    return (
        <div className={clsx('table-footer', className)}>
            <span className="page-counter">
                Page {pagination?.page} of {pagination?.maxPages}
            </span>

            <ReactPaginate
                previousLinkClassName="hidden"
                nextLinkClassName="hidden"
                onPageChange={(selectedItem) =>
                    handlePageChange(selectedItem.selected + 1)
                }
                // initialPage={initialPage}
                // forcePage={initialPage}
                pageCount={pagination?.maxPages}
                pageRangeDisplayed={5}
                containerClassName="pagination"
                pageClassName="page-item"
                breakClassName={'page-item-dots'}
                activeClassName="active"
            />

            <div className="flex items-center gap-8">
                <button
                    className="btn btn--navigation btn--square btn--xs rounded-full"
                    onClick={() => handlePageChange(pagination?.page - 1)}
                    disabled={pagination?.page === 1}
                >
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M4.16602 9.99992H15.8327"
                            stroke="#7D8491"
                            strokeWidth="1.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M8.33268 5.83325L4.16602 9.99992"
                            stroke="#7D8491"
                            strokeWidth="1.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M8.33268 14.1667L4.16602 10"
                            stroke="#7D8491"
                            strokeWidth="1.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </button>
                <button
                    className="btn btn--navigation btn--square btn--xs rounded-full"
                    onClick={() => handlePageChange(pagination?.page + 1)}
                    disabled={pagination?.page === pagination?.maxPages}
                >
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M15.8327 9.99992H4.16602"
                            stroke="#7D8491"
                            strokeWidth="1.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M11.666 14.1667L15.8327 10"
                            stroke="#7D8491"
                            strokeWidth="1.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M11.666 5.83325L15.8327 9.99992"
                            stroke="#7D8491"
                            strokeWidth="1.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </button>
            </div>
        </div>
    )
}

export default Pagination
